import { apiClient } from './client'
import type {
  TryoutSetupClub,
  TryoutSetupEvent,
  TryoutSetupSeason,
} from './tryoutSetup'
import type { ParticipantListRole } from './participantList'

export interface TryoutContextSession {
  recommendationPolicy?:import('./sessionRecommendationTargets').SessionRecommendationPolicy|null
  id: string
  title: string
  name?: string
  startsAt?: string
  endsAt?: string
  venueName?: string
  court?: string
  address?: string
  location?: string
  status?: string
  archived?: boolean
  updatedAt?: string
}

export interface TryoutContextPermissions {
  canManageEvent?: boolean
  canEditSessions?: boolean
  canMarkAttendance?: boolean
}

export interface TryoutContextResponse {
  features?: import('./programSettings').ProgramFeatures
  club: TryoutSetupClub
  season: TryoutSetupSeason
  event: TryoutSetupEvent & {
    eventNoun?: string
    /** @deprecated Compatibility alias; use participantNoun. */
  participantPronoun?: string
    sessionNoun?: string
    minParticipantNumber?: number | string
    maxParticipantNumber?: number | string
  }
  sessions: TryoutContextSession[]
  roles: ParticipantListRole[]
  permissions: TryoutContextPermissions
}

export class TryoutContextAPI {
  async loadContext(
    seasonId: string,
    tryoutId: string,
    clubId?: string,
    signal?: AbortSignal
  ): Promise<TryoutContextResponse> {
    const query = clubId ? { clubId } : undefined
    return apiClient.get(`/v2/season/${seasonId}/tryouts/${tryoutId}/context`, query, signal)
  }
}

export const tryoutContextAPI = new TryoutContextAPI()
